import { Injectable } from '@angular/core';
import { APIService } from "./api.service";
import { SystemSettingTypes} from "../enum/SystemSettingsType";
import { ISystemSetting } from "../interfaces/ISystemSetting";

@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService {

  constructor(private apiService: APIService) { }

  public getByType(type: SystemSettingTypes) {
    return this.apiService.MakeGetRequest<ISystemSetting>(`system-settings/${type}`);
  }

  public updateAdminTerms(newTerms: string) {
    return this.apiService.MakePutRequest(`system-settings/update-terms`, { newTerms });
  }
}
